import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MeSessionService } from './core/auth/me-session.service';
import { SessionTimeoutService } from './core/auth/session-timeout.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, OnDestroy {
  private readonly sessionTimeoutService = inject(SessionTimeoutService);
  private readonly meSessionService = inject(MeSessionService);

  protected get showSessionWarning(): boolean {
    return this.sessionTimeoutService.warningVisible;
  }

  protected get sessionWarningSecondsLeft(): number {
    return this.sessionTimeoutService.warningSecondsLeft;
  }

  ngOnInit(): void {
    this.sessionTimeoutService.start();
    if (!this.meSessionService.loaded() && !this.meSessionService.loading()) {
      this.meSessionService.refresh();
    }
  }

  ngOnDestroy(): void {
    this.sessionTimeoutService.stop();
  }

  protected prolongerSession(): void {
    void this.sessionTimeoutService.extendSession();
  }

  protected seDeconnecterMaintenant(): void {
    void this.sessionTimeoutService.logoutNow();
  }
}
